export default (value, {from, to, inclusivity = '()', format = 'YYYY-MM-DD', units = 'days'}, validator, fieldName) => {

    let target = moment(value, format, true)

    let fromTime = validator.form().has(from)
                    ? validator.form().get(from)
                    : from

    fromTime = moment(fromTime)

    let toTime = validator.form().has(to)
                    ? validator.form().get(to)
                    : to

    toTime = moment(toTime)

    if( ! target.isValid() ) {
        return {
            result: false,
            message: validator.$errorMessages[ '_invalid_format' ]( fieldName, {format} )
        }
    }

    if( ! fromTime.isValid() || ! toTime.isValid() ) {
        return false
    }

    return target.isBetween(fromTime, toTime, units, inclusivity)
}
